/**
 * Global Context
 * Used strictly for things that need to be globally available, such as profile information
 */

import React, { createContext, Dispatch, SetStateAction, useState } from 'react';
import { UserProfile } from '../interfaces/userProfile.interface';

export const GlobalContext = createContext<{
  profile: UserProfile | undefined;
  setProfile: Dispatch<SetStateAction<UserProfile | undefined>>;
}>({
  profile: undefined,
  setProfile: profile => {},
});

export const Provider = (props: { profile: UserProfile | undefined; children: JSX.Element }) => {
  const { profile: initialProfile, children } = props;
  const [profile, setProfile] = useState<UserProfile | undefined>(initialProfile);

  const globalContext = {
    profile,
    setProfile,
  };

  return <GlobalContext.Provider value={globalContext}>{children}</GlobalContext.Provider>;
};

export const { Consumer } = GlobalContext;
